import React from 'react'
import { Link } from 'react-router-dom'
import CourseLocationCard from './CourseLocationCard'
import CourseMetadata from './CourseMetadata'

// Shared course-level header used by both the course (group) view and the layout view:
// the course name, a location card (map + address + directions), and the community metadata.
// When `to` is provided the title becomes a link (used by the layout view to go back to
// the course overview); otherwise it renders as plain text.
export default function CourseHeader({
  name,
  groupId,
  to = null,
  location = null,
  locationLabel = '',
  directions = '',
}) {
  return (
    <div className="course-header">
      <h1 className="course-header--title">
        {to ? <Link to={to}>{name}</Link> : name}
      </h1>
      <CourseLocationCard
        location={location}
        locationLabel={locationLabel}
        directions={directions}
      />
      {groupId != null && <CourseMetadata groupId={groupId} />}
    </div>
  )
}
